import { Entity, ExportType } from '@debbie/common/dist/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import { downloadFile } from '@debbie/cortex/dist/files.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useMe } from '@debbie/cortex/dist/me/index.js';
import { useTenantId } from '@debbie/cortex/dist/tenant/index.js';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { APIBASE } from '../../../config.js';
import { errorNotification } from '../../../utils/errors.js';
import Button from '../../Button.js';
import ButtonGroup from '../../ButtonGroup.js';
import { Download, Settings } from '../../Icons/index.js';
import CaseVoucherExportEditor from './CaseVoucherExportEditor.js';
import { caseVoucherExportSettingsSchema, exportSettingsKey, readExportSettings, } from './export-settings.js';
const CaseVoucherExport = (props) => {
    const me = useMe();
    const tenantId = useTenantId();
    if (!h.hasData(me) || tenantId == null) {
        return null;
    }
    const storageKey = exportSettingsKey(me.data.id, tenantId, props.transactionAccount?.transactionAccountId ?? 'case-vouchers');
    return (React.createElement(ExportControls, { key: storageKey, ...props, storageKey: storageKey, tenantId: tenantId }));
};
const ExportControls = (props) => {
    const lang = useSelector((state) => state.lang);
    const [open, setOpen] = useState(false);
    const [settings, setSettings] = useState(() => readExportSettings(props.storageKey, props.transactionAccount != null));
    const hasSelection = props.selectedIds.length > 0;
    const saveSettings = useMutation((draft) => {
        const preferences = caseVoucherExportSettingsSchema.parse(draft);
        localStorage.setItem(props.storageKey, JSON.stringify(preferences));
        return preferences;
    }, {
        onSuccess: (preferences) => {
            setSettings(preferences);
            setOpen(false);
        },
        onError: (error) => {
            reportError(error);
            errorNotification(lang, error, 'update', lang.errorEntities.settings);
        },
    });
    const exportDeposits = useMutation(async () => {
        const request = {
            ...settings,
            deposits: props.transactionAccount != null,
            ...(hasSelection
                ? { ids: props.selectedIds }
                : {
                    transactionAccountId: props.transactionAccount?.transactionAccountId,
                    filter: props.filter,
                }),
        };
        await downloadFile(`${APIBASE}/v1/${props.tenantId}/case-vouchers/export?lang=${lang.is.currently}`, `${props.transactionAccount?.name ?? lang.caseVouchers.exportFileName} ${moment().format('DD.MM.YYYY')}.${settings.exportType === ExportType.Csv ? 'csv' : 'xlsx'}`, { method: 'POST', body: JSON.stringify(request) });
    }, {
        onSuccess: props.onExport,
        onError: (error) => errorNotification(lang, error, 'any', lang.errorEntities.deposit),
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Toolbar, null,
            React.createElement(Scope, null,
                props.heading != null && React.createElement("h3", null, props.heading),
                React.createElement("span", { title: hasSelection
                        ? lang.deposits.selectedExportHint
                        : lang.deposits.filteredExportHint }, hasSelection
                    ? `${lang.deposits.exportSelected} (${props.selectedIds.length})`
                    : lang.deposits.exportFiltered)),
            React.createElement(Actions, null,
                props.actions,
                React.createElement(ExportButtons, null,
                    React.createElement(Button, { download: true, loading: exportDeposits.isLoading, onClick: () => exportDeposits.mutate() },
                        React.createElement(ButtonContent, null,
                            React.createElement(Download, null),
                            lang.misc.export,
                            " ",
                            settings.exportType)),
                    React.createElement(SettingsButton, { onClick: () => setOpen(true), disabled: exportDeposits.isLoading, tooltip: lang.deposits.customizeExport },
                        React.createElement(Settings, null),
                        React.createElement(VisuallyHidden, null, lang.deposits.customizeExport))))),
        open && (React.createElement(CaseVoucherExportEditor, { settings: settings, accountName: props.transactionAccount?.name ?? lang.entities[Entity.CaseVoucher], deposits: props.transactionAccount != null, saving: saveSettings.isLoading, onSave: (draft) => saveSettings.mutate(draft), onClose: () => setOpen(false) }))));
};
export default CaseVoucherExport;
const Toolbar = styled.div `
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
  justify-content: space-between;
  width: 100%;
  padding: 16px 0;
  border-bottom: 1px solid #e5e6ef;
`;
const Actions = styled.div `
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
  margin-left: auto;
  > .btn {
    box-shadow: none;
  }
`;
const Scope = styled.div `
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-right: 8px;
  font-size: 12px;
  h3 {
    margin: 0 0 3px;
    font-size: 16px;
  }
  span {
    color: #72738a;
    font-size: 11px;
  }
`;
const ButtonContent = styled.span `
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;
const ExportButtons = styled(ButtonGroup) `
  display: inline-flex;
  align-items: stretch;
  white-space: nowrap;
`;
const SettingsButton = styled(Button) `
  padding-left: 14px;
  padding-right: 14px;
  min-width: 42px;
`;
const VisuallyHidden = styled.span `
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;
//# sourceMappingURL=CaseVoucherExport.js.map